// مستند قائمة سجل الطلبات بصيغة PDF احترافية — بهوية تقارير HELCOO وأزرار طباعة/تحميل/مشاركة/إغلاق.
import { css } from "../payroll/reportTokens";
import { esc, today } from "../payroll/reportFormat";
import { brandLogo, brandName } from "../payroll/reportBrand";
import { buttons, footer } from "./requestDocParts";
import { RL } from "./requestDocLabels";
import { refLine } from "../reports/refLine";
import { shareBar } from "../reports/shareBar";
import { pdfScript } from "../reports/pdfActions";
import { openReportOverlay, patchReportOverlay } from "../reports/reportOverlay";
import { shareReport, updateShareHtml } from "../../api/reportShare";

const tableHtml = (rows, headers) =>
  `<table><thead><tr>${headers.map((h) => `<th>${esc(h.label)}</th>`).join("")}</tr></thead><tbody>${
    (rows.length ? rows : [{}]).map((r) => `<tr>${headers.map((h) => `<td>${esc(rows.length ? r[h.key] ?? "—" : "—")}</td>`).join("")}</tr>`).join("")
  }</tbody></table>`;

const listHeader = (L, title, brand, count) =>
  `<div class="header">${brandLogo(brand)}${brandName(brand)}
    <h1>${esc(title)}</h1>
    <p>${esc(L.generatedAt)}: ${today()} · ${esc(String(count))}</p></div>`;

export const buildRequestsListHtml = (title, rows, headers, lang = "ar", options = {}, share = null) => {
  const L = RL[lang === "en" ? "en" : "ar"];
  const rtl = lang !== "en";
  const docTitle = share?.title || title;
  return `<!DOCTYPE html>
<html lang="${rtl ? "ar" : "en"}" dir="${rtl ? "rtl" : "ltr"}">
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>${docTitle}</title><style>${css(false)}</style></head>
<body>
${buttons(L, share, options.pdfUrl)}
${refLine(share, L.refLabel)}
${listHeader(L, title, options.brand, rows.length)}
${tableHtml(rows, headers)}
${footer(L)}
${shareBar(share?.url, L.copied)}
${pdfScript(options.pdfUrl, docTitle, L)}
</body></html>`;
};

// فتح فوري داخل التطبيق (طبقة واحدة) بلا تذكرة/استطلاع: الأزرار تظهر حالاً، والتحميل/المشاركة
// يتمّان بطلب PDF واحد مباشر (renderPdfDirect) — نفس الحل الجذري السريع لبقية التقارير.
export const openRequestsListOverlay = async (title, rows, headers, lang, brand) => {
  const options = { brand };
  openReportOverlay({
    html: buildRequestsListHtml(title, rows, headers, lang, options, null),
    shareUrl: null, fileName: title, lang,
  });
  const share = await shareReport(title, "", { company: brand?.name }).catch(() => null);
  if (!share) return;
  patchReportOverlay({ shareUrl: share.short || share.url });
  if (share.token) {
    updateShareHtml(share.token, buildRequestsListHtml(title, rows, headers, lang, options, share)).catch(() => {});
  }
};
